export default __webpack_public_path__ + "static/media/courses8.a66a4bae.svg";